import { IWizardStep } from "../../../../wizard/types";
import validator from "../../validators/step4/validator";
import Content from "../../create/step4/Content";

export const editConfigStep4: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Edit course",
  },
  content: Content,
  validator: validator,
  stepName: "step4",
};
